import { buildConnectorSiteIds } from './mapSessionResponse';
import { SYNC_ERROR_CODES } from './constants';

export const buildCreateImplementationPayload = (cache, selectedCompanyIds) => ({
    sessionId: cache.sessionId,
    siteIds: buildConnectorSiteIds(cache.companies, selectedCompanyIds),
    companyName: cache.userCompanyName,
    email: cache.userEmail,
});

export const mapCreateImplementationError = (error) => {
    if (error?.response?.status === 401) {
        return { needsSageIdLogin: true };
    }

    return { success: false, errorCode: SYNC_ERROR_CODES.CREATE_FAILED };
};

export const mapImplementationStatusResponse = (data) => {
    if (data?.error) {
        return { failed: true, error: data.error };
    }

    if (data?.status === 1) {
        return {
            complete: true,
            url: data?.url,
            implementationId: data?.implementationId,
        };
    }

    return { pending: true };
};
